import { adminFetch } from "./base";

export interface AdminTeamMember {
  readonly id: string;
  readonly email: string;
  readonly full_name: string;
  readonly role: "manager" | "agent";
  readonly platform: "cieda" | "djayma";
  readonly department_name: string;
  readonly department_id: string;
  readonly is_active: boolean;
  readonly created_at: string;
}

export interface TeamListResponse {
  readonly admins: readonly AdminTeamMember[];
  readonly pagination: { readonly page: number; readonly limit: number; readonly total: number };
}

export interface InviteAdminInput {
  readonly email: string;
  readonly full_name: string;
  readonly role: "manager" | "agent";
  readonly department_id: string;
  readonly platform: "cieda" | "djayma";
}

export const teamApi = {
  list: (params: { q?: string; page?: number } = {}) => {
    const qs = Object.entries(params)
      .filter(([, v]) => v != null && v !== "")
      .map(([k, v]) => `${k}=${encodeURIComponent(String(v))}`)
      .join("&");
    return adminFetch<TeamListResponse>(`/api/admin/team${qs ? `?${qs}` : ""}`);
  },
  invite: (data: InviteAdminInput) =>
    adminFetch<{ readonly admin: AdminTeamMember; readonly note: string }>("/api/admin/team", {
      method: "POST",
      body: JSON.stringify(data),
    }),
  update: (
    id: string,
    data: Partial<{ role: string; department_id: string; is_active: boolean; full_name: string }>,
  ) =>
    adminFetch<{ readonly admin: AdminTeamMember }>(
      `/api/admin/team/${encodeURIComponent(id)}`,
      {
        method: "PATCH",
        body: JSON.stringify(data),
      },
    ),
  deactivate: (id: string) =>
    adminFetch<{ readonly success: boolean }>(
      `/api/admin/team/${encodeURIComponent(id)}`,
      {
        method: "DELETE",
      },
    ),
} as const;
